<template>
    <div>
        <template v-if="!edit">
            <div class="spacer"></div>
            <h3 class="h4">Conocé más sobre tecnicaturas</h3>
        </template>

        <div class="row">

            <div class="col-12 col-lg-3 col-md-6 col-sm-6 p-3" v-for="(technique, index) in techniques" :key="index">
                <RouterLink :to="{name: techniqueLink, params: {id: technique.id}}" class="text-dark text-decoration-none bg-light card text-center pointer">
                    <div class="card-body card-technique">
                        <i class="fa-5x fas mt-3" :class="`${technique.icon} text-${!(index % 2) ? 'success' : 'danger'}`"></i>
                        <p class="mt-3">{{technique.title}}</p>
                    </div>
                </RouterLink>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props:{
        edit:{
            type: Boolean,
            default: false
        }
    },
    name: 'Technique',
    created(){
        this.$store.dispatch('technique/getTechniques')
    },
    computed:{
        techniques(){
            return this.$store.state.technique.techniques
        },
        techniqueLink(){
            return this.edit ? 'EditTechnique' : 'Technique'
        }
    }
}
</script>